import {Parameter} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export enum ThemeType {
	DEFAULT = "default",
	RED = "red",
	GREEN = "green",
	BLUE = "blue",
	DARK = "dark",
	CUSTOM = "custom"
}

export enum BackgroundType {
	DEFAULT = "default",
	CUSTOM = "custom",
	HIDDEN = "hidden"
}

export enum LogoType {
	DEFAULT = "default",
	CUSTOM = "custom"
}

export class DesignType implements Parameter {
	public logoType?: LogoType;
	public logo?: string;
	public backgroundType?: BackgroundType;
	public background?: string;
	public hideBackground?: boolean;
	public themeType?: ThemeType;
	public theme?: string;

	constructor(data: any) {
		this.logoType = FunctionHelper.exists(data?.logoType) ? data.logoType : LogoType.DEFAULT;
		this.logo = FunctionHelper.exists(data?.logo) ? data.logo : "";
		this.backgroundType = FunctionHelper.exists(data?.backgroundType) ? data.backgroundType : BackgroundType.DEFAULT;
		this.background = FunctionHelper.exists(data?.background) ? data.background : "";
		this.hideBackground = FunctionHelper.exists(data?.hideBackground) ? data.hideBackground : false;
		this.themeType = FunctionHelper.exists(data?.themeType) ? data.themeType : ThemeType.DEFAULT;
		this.theme = FunctionHelper.exists(data?.theme) && data.theme !== "" ? data.theme : DesignType.getThemeDefault();
	}

	public static getLogoTypeDescription(): string {
		return "";
	}

	public static getLogoTypeDefault(): LogoType {
		return LogoType.DEFAULT;
	}

	public static getLogoDescription(): string {
		return "";
	}

	public static getLogoDefault(): string {
		return "";
	}

	public static getBackgroundTypeDescription(): string {
		return "";
	}

	public static getBackgroundTypeDefault(): BackgroundType {
		return BackgroundType.DEFAULT;
	}

	public static getBackgroundDefault(): string {
		return "";
	}

	public static getHideBackgroundDefault(): boolean {
		return false;
	}

	public static getThemeTypeDescription(): string {
		return "";
	}

	public static getThemeTypeDefault(): ThemeType {
		return ThemeType.DEFAULT;
	}

	public static getThemeDescription(): string {
		return "";
	}

	public static getThemeDefault(): string {
		return (
			":root {\n" +
			"    --primary-color: #fbc200;\n" +
			"    --hover-color: #fff3c8;\n" +
			"    --active-color: #ffdb62;\n" +
			"    --highlight-color: #3333ff;\n" +
			"    --border-primary-color: #957300;\n" +
			"    --body-color: #fff;\n" +
			"\n" +
			"    --success-bg-color: #dff0d8;\n" +
			"    --success-text-color: #3c763d;\n" +
			"    --success-border-color: #d6e9c6;\n" +
			"\n" +
			"    --info-bg-color: #d9edf7;\n" +
			"    --info-text-color: #31708f;\n" +
			"    --info-border-color: #bce8f1;\n" +
			"\n" +
			"    --warning-bg-color: #fcf8e3;\n" +
			"    --warning-text-color: #8a6d3b;\n" +
			"    --warning-border-color: #faebcc;\n" +
			"\n" +
			"    --danger-bg-color: #f2dede;\n" +
			"    --danger-text-color: #a94442;\n" +
			"    --danger-border-color: #ebccd1;\n" +
			"}"
		);
	}

	public static fromJson(data: any): DesignType {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new DesignType(data);
	}

	public toJson(): any {
		return {
			'logoType': this.logoType,
			'logo': this.logo,
			'backgroundType': this.backgroundType,
			'background': this.background,
			'hideBackground': this.hideBackground,
			'themeType': this.themeType,
			'theme': this.theme
		};
	}

	public clone(): DesignType {
		return DesignType.fromJson(this.toJson());
	}
}